import { SecondaryButtonStyle, SimpleButtonStyle } from '../../button/peugeot/peu-button';
import { baseColor, primaryColor, secondaryColor } from '../../../styles/general/theme';
import { paddingInline } from '../../../styles/general/logical-properties';
import { css } from 'styled-components';

export const PeuRichTextStyle = css<{
  checkMarkIconSrc?: string;
  standardPro?: boolean;
  disableOverflow?: boolean;
  overFlowWrap?: string;
  removeTopMargin?: boolean;
}>`
  overflow: inherit;

  a {
    text-decoration: none;
  }

  img {
    max-width: 100%;
  }

  .primary-button,
  .button-primary {
    ${SimpleButtonStyle};
    display: inline-flex;

    span {
      color: ${baseColor(900)} !important;
      font-size: inherit;
    }
  }

  .secondary-button,
  .button-secondary {
    ${SecondaryButtonStyle};
    display: inline-flex;

    :hover {
      span {
        color: ${baseColor(900)} !important;
      }
    }

    span {
      color: ${secondaryColor(300)} !important;
      font-size: inherit;
    }
  }

  ul {
    list-style: none;
    margin-left: 0;
    padding-left: 0;
  }

  li {
    ${paddingInline('25px', 0)};
    list-style: none;
    position: relative;
  }

  li:before {
    content: url(${(p) => p.checkMarkIconSrc});
    position: absolute;
    top: 0;
    left: 0;
  }

  p {
    margin-top: 1em;
    margin-bottom: 1em;
  }

  ${(p) =>
    p.disableOverflow &&
    css`
      overflow: hidden;
    `};

  ${(p) =>
    p.removeTopMargin &&
    css`
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        margin-top: 0 !important;
      }
    `};

  ${(p) =>
    p.standardPro &&
    css`
      p {
        margin: 0;
      }

      td {
        padding: 10px;
        border-right: 3px solid ${baseColor(900)};

        &:last-child {
          border-right: none;
        }
      }

      tbody tr:first-child {
        background-color: ${primaryColor(200)};
        color: ${baseColor(900)};
      }

      tr {
        &:nth-child(odd) {
          background-color: ${baseColor(900)};
        }

        &:nth-child(even) {
          background-color: ${baseColor(700)};
        }
      }
    `};

  .richtext-tooltip {
    & svg {
      circle {
        stroke-width: 0.7;
        stroke: ${primaryColor(200)};
      }

      path {
        fill: ${primaryColor(200)};
        stroke-width: 0.5;
        stroke: ${primaryColor(200)};
      }
    }
  }
`;
